const formNull = {
  formIdNull: "new-user-formNull",
  formFieldNull: { },
};

export default formNull;
